export default {
    components: {},
    props: {
        department: {
            type: String,
            required: true,
        },
    },
    data,
    computed: getComputed(),
    watch: getWatches(),
    created,
    methods: getMethods(),
};

function data(){
    const vm = this;
    return {
        isLoadingLeads: false,
        leads: [],
        errorMessages: [],
        selectedLead: null,
        tableColumns: [
            {
                key: 'case_no',
                label: 'Case',
                sortable: true,
            },
            {
                key: 'case.Status',
                label: 'Status',
                sortable: true,
                formatter: vm.getStatusText,
            },
            {
                key: 'case.resource_no',
                label: 'Assigned To Person',
                sortable: true,
            },
            {
                key: 'id',
                label: 'ID',
                sortable: true,
            },
            {
                key: 'company',
                label: 'Company',
                sortable: true,
            },
            {
                key: 'contact',
                label: 'Contact',
                sortable: true,
            },
            {
                key: 'department',
                label: 'Department',
                sortable: true,
            },
            {
                key: 'priority',
                label: 'Priority',
                sortable: true,
            },
            {
                key: 'message',
                label: 'Message',
                sortable: true,
            },
            {
                key: 'updated_at',
                label: 'Datetime',
                sortable: true,
                formatter: vm.getDateText,
            },
            {
                key: 'user.name',
                label: 'Name',
                sortable: true,
            },
        ],
    };
}

function getComputed(){}

function getWatches(){
    return {
        department,
    };

    function department(){
        const vm = this;
        vm.searchLeads();
    }
}

function created(){
    const vm = this;
    vm.searchLeads();
}

function getMethods(){
    return {
        searchLeads,
        displayErrorMessage,
        getStatusText,
        getDateText,
        updateCaseNumber,
    };

    function searchLeads(){
        const vm = this;
        vm.isLoadingLeads = true;
        vm.$emit('is-loading-leads', true);
        const query = {
            department: vm.department
        };
        Vue.appApi().authorized().leads().indexLeads(query)
            .then(setLeadsData)
            .catch(vm.displayErrorMessage)
            .finally(stopSpinner);

        function setLeadsData(data){
            vm.leads = data.data;
        }

        function stopSpinner(){
            vm.isLoadingLeads = false;
            vm.$emit('is-loading-leads', false);
        }
    }

    function displayErrorMessage(error){
        const vm = this;
        if(error){
            const errorMessage = typeof error === 'string' ? error : (error.appMessage || error.message);
            vm.errorMessages.push(errorMessage);
        }
    }

    function getStatusText(status){
        let statusText = '';
        if(status === 0){
            statusText = 'OPEN';
        }
        if(status === 1){
            statusText = 'ON HOLD';
        }
        if(status === 2){
            statusText = 'CLOSED';
        }
        return statusText;
    }

    function getDateText(updated_at){
        return Vue.moment(updated_at).format('YYYY MMM D H:mm A');
    }

    function updateCaseNumber(lead){
        const vm = this;
        const payload = {
            case_no: lead.case_no
        };
        Vue.appApi().authorized().leads(lead.id).updateLead(payload)
            .catch(vm.displayErrorMessage);
    }
}
